@use "ui/styles/colors";
@use "ui/styles/colorsOld";

.wrapper {
  background-color: colorsOld.$stoneLightX4;
  padding: 48px 0;
  border-radius: 4px;
  text-align: center;

  :global {
    .cta-container {
      max-width: 390px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;

      .cta-title {
        color: colorsOld.$stoneDarkX1;
        font-size: 18px;
        font-weight: bold;
      }

      .cta-text {
        color: colorsOld.$stoneDark;
        margin: 12px auto 24px;
        font-size: 14px;
        line-height: 130%;

        a {
          color: colors.$blue;
          text-decoration: none;
        }

        button {
          margin: 0 auto;
        }
      }
    }
  }
}
